<template>
    <div>
        <router-link tag="a" class="back-button right mb11" to="/portfolio">Back to portfolio</router-link>
        <h6 class="headline-sm">PARKS</h6>
        <ul class="portfolio-list">
            <li>
                <img img src="images/Our-Work-Page/Parks/parks1.png" alt="">
                <strong class="portfolio-list-name">Friends of Broadneck Park</strong>
                <span class="portfolio-list-location">Annapolis, MD</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Parks/parks2.png" alt="">
                <strong class="portfolio-list-name">Friends of the Park</strong>
                <span class="portfolio-list-location">Lambertville, NJ</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/Parks/parks3.png" alt="">
                <strong class="portfolio-list-name">Children’s Memorial Park</strong>
                <span class="portfolio-list-location">Virginia, MN</span>
            </li>
        </ul>
    </div>
</template>

<script type="text/jsx">
    export default {
        name: 'parks',
        metaInfo: {
            title: 'Parks'
        }
    }
</script>



// WEBPACK FOOTER //
// Parks.vue?08ba3e5e